module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAWCAYAAAChWZ5EAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEHSURBVHgB7ZZNrsFQFMf/ldeIeq/yxISIqZkJGzAWxmID5hbABmxAjG2ABdiAscRAkIhv4qMhgtIjSARJ772STvqbNDm96fnd03M/pKYSOcNCHLAYW8AWEBb4jbshgpCAM+yEN/MPEYQE3FEXlJgLjj/+z/ywDJb9z8Pv5fckVWh17RE/aTr0jQ4zSCw7oRyQESoHjedn70VliVlpblqAqXaHwQHddA+r6vrlHSUcFsaYFKemkzMLEKdbon1r/xQf5kdvxb4uQNCvoBVA3GerplTwwCVAnU+J+7kB2onOdeZKTOFaDRLPcezLerGqrY2eOD5iHqMC1CPbxg4sSPZ9ABZjC1gucAFtLVWMeD0p0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vi.png
// module id = fhnC
// module chunks = 18